import { AxiosResponse } from 'axios';
import { Result } from '@/main/models/common/resultResponse';
import { DirectAssignCriteriaResponse } from '@/main/models/response';
import { DirectAssignCriteriaRequest } from '@/main/models/request';

export abstract class IDirectAssignCriteriaApi {
  abstract saveDirectAssignCriteria(
    request: DirectAssignCriteriaRequest
  ): Promise<AxiosResponse<Result<DirectAssignCriteriaResponse>>>;

  abstract deleteDirectAssignCriteria(
    request: string[]
  ): Promise<AxiosResponse<Result<DirectAssignCriteriaResponse[]>, any>>;
}
